import { RequestDataReadOnly } from "../request-data-section/request-data-read-only.content";
import { EvaluationSection } from "../evaluation-section.content";
import { InvoiceSectionContainer } from "../invoice-section/invoice-section.container";
import type { ExternalProviderDashboardVM } from "@shared-kernel/application/ports/external-provider/external-provider-repository";
import type { EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS } from "@academy-context/shared/domain/types/enums/external-provider-batch-request";

interface Props {
  data: ExternalProviderDashboardVM;
  currentStatus: EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS;
  onEvaluationSubmitted: () => void;
}

/**
 * Invoice Editable Phase - Provider can submit/edit invoice and evaluations
 * Shown when status is: WAITING_FOR_INVOICE or INVOICE_REFUSED
 */
export const InvoiceEditablePhase = ({ data, onEvaluationSubmitted }: Props) => {
  return (
    <>
      <EvaluationSection
        participationId={data.participation?.id ?? null}
        objectives={data.objectives}
        appraisal={data.appraisal}
        onSubmitted={onEvaluationSubmitted}
      />
      <InvoiceSectionContainer data={data} />
      <RequestDataReadOnly data={data} />
    </>
  );
};
